import { useAppDispatch } from "../../hooks/useAppDispatch";
import { util, chatApi } from "../../store/chat/chat.api";
import { IOffer } from "../../models/ordersModel";
import { store } from "../../store";

export const useUpdateChatOffer = () => {
    const dispatch = useAppDispatch();

    return async (chatId: string, newOffer: Partial<IOffer>) => {

        // Проверяем, есть ли данные в кеше
        const currentData = chatApi.endpoints.getChatInfo.select(chatId)(store.getState());
        if (!currentData.data) {
            await dispatch(chatApi.endpoints.getChatInfo.initiate(chatId));
        }

        dispatch(
            util.updateQueryData("getChatInfo", chatId, (chat) => {
                if (!chat) return;
                return {
                    ...chat,
                    order: {
                        ...chat.order,
                        offer: newOffer ? newOffer : null,
                    },
                };
            })
        );
    };
};
